export const RIBBON_STRIPS = {
  // Main container
  CONTAINER: 'ribbon-strips-container',
  STRIP_BUTTON: 'ribbon-strip-button',

  // Sort By Strip
  SORT_BY_STRIP: 'sort-by-strip',
  SORT_BY_MINIMIZE_BUTTON: 'sort-by-minimize-button',
  MINUS_ICON: 'sort-by-minus-icon',

  // Organize By Strip
  ORGANIZE_BY_STRIP: 'organize-by-strip',
  ORGANIZE_BY_STRIP_TITLE: 'organize-by-strip-title',
  ORGANIZE_BY_DROPDOWN_FIRSTMENU_BTN_TEXT: 'organize-by-dropdown-firstmenu-btn-text',
  ORGANIZE_BY_DROPDOWN_SECONDMENU_BTN_TEXT: 'organize-by-dropdown-secondmenu-btn-text',
  ORGANIZE_BY_FIRST_SELECT: 'organize-by-first-select',
  ORGANIZE_BY_SECOND_SELECT: 'organize-by-second-select',
  ORGANIZE_BY_SHOW_EMPTY_SWITCH: 'organize-by-show-empty-switch',
  ORGANIZE_BY_RESTORE_BUTTON: 'organize-by-restore-button',
  ORGANIZE_BY_MINIMIZE_BUTTON: 'organize-by-minimize-button',

  // Bar Colors Strip
  BAR_COLORS_STRIP: 'bar-colors-strip',
  BAR_COLORS_PIER_TITLE: 'bar-colors-pier-title',
  BAR_COLORS_SCROLL_LEFT: 'bar-colors-scroll-left',
  BAR_COLORS_SCROLL_RIGHT: 'bar-colors-scroll-right',

  // Inspect Path Strip
  INSPECT_PATH_STRIP: 'inspect-path-strip',
  INSPECT_PATH_STOP_BUTTON: 'inspect-path-stop-button',

  // Comparison Bar
  COMPARISON_BAR: 'comparison-bar',
  COMPARISON_DOWNLOAD_EXCEL: 'comparison-download-excel',
  COMPARISON_STOP_BUTTON: 'comparison-stop-button'
} as const;
